import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgMail = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="#C737AB" d="M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0z" />
      <g stroke="#FFF" transform="translate(3.959 5)">
        <rect width={9.471} height={6.615} x={0.5} y={0.5} rx={1} />
        <path d="m1.04 1.229 4.32 2.236 4.017-2.236" />
      </g>
    </g>
  </svg>
);
const Memo = memo(SvgMail);
export default Memo;
